var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-panel-filter"},[_vm._t("panelFilterPrepend"),_vm._l((_vm.items),function(item,i){return _c('panel-filter-items',_vm._g(_vm._b({key:i,attrs:{"item":item,"index":i}},'panel-filter-items',_vm.$attrs,false),_vm.$listeners))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }